import type { SearchableSelectConfig } from '@/components/SearchableSelect';

export enum REQUEST_STATUS {
  PENDING = 'pending',
  COMPLETED = 'completed',
  FAILED = 'failed'
}

export const REQUESTS_QUICK_FILTERS: SearchableSelectConfig[] = [
  {
    field: 'requester.name',
    title: 'Requester',
    config: {
      searchable: false,
      showCounts: true,
      variant: 'dropdown'
    },
    filterOptions: []
  },
  {
    field: 'sensors',
    title: 'Sensors',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  },
  {
    field: 'status',
    title: 'Status',
    config: {
      searchable: false,
      showCounts: true
    },
    filterOptions: []
  }
];

export default REQUEST_STATUS;
